// extracted by mini-css-extract-plugin
module.exports = {"result":"styles_result__icpje"};